import { useEffect, useState } from "react";
import XYZLABS_CustomComplete from '../components/Order/XYZLABS_Complete';
import CTS_CustomComplete from '../components/Order/CTS_Complete';
import CTS_Footer from '../components/AppFooter/CTS_Footer';
import XYZLABS_Footer from '../components/AppFooter/XYZLABS_Footer';
import CTS_Header from '../components/AppHeader/CTS_Header';
import XYZLABS_Header from '../components/AppHeader/XYZLABS_Header';

// Map available components to dynamic keys
const components = {
  CTS_Footer,
  XYZLABS_Footer,
  XYZLABS_Complete: XYZLABS_CustomComplete,
  CTS_Complete: CTS_CustomComplete,
  CTS_Header,
  XYZLABS_Header,
};

function DynamicComponent({ componentName }) {
  const Component = components[componentName];
  return Component ? <Component /> : null;
}

function FileDisplay({ filePath, onFileFound }) {
  const [fileExists, setFileExists] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkFile = async () => {
      try {
        const response = await fetch(filePath, { method: 'GET' });
        const contentType = response.headers.get("content-type") || "";

        const isImage = contentType.includes("image");
        const isJS = contentType.includes("javascript") || filePath.endsWith(".js");

        const exists = response.ok && (isImage || isJS);
        setFileExists(exists);
        onFileFound?.(exists);
      } catch (error) {
        setFileExists(false);
        onFileFound?.(false);
      } finally {
        setLoading(false);
      }
    };

    checkFile();
  }, [filePath, onFileFound]);

  if (loading) return <p>Loading...</p>;
  if (!fileExists) return null;

  const extension = filePath.split('.').pop().toLowerCase();
  const baseName = filePath.split('/').pop().split('.')[0];

  if (extension === 'jpg' || extension === 'png' || extension === 'gif') {
    return (
      <img
        src={filePath}
        alt={`${baseName} image`}
        style={{ maxWidth: '100%', height: 'auto' }}
      />
    );
  }

  if (components[baseName]) {
    return <DynamicComponent componentName={baseName} />;
  }

  return null;
}

export default FileDisplay;
